export default "__VITE_ASSET__D10HZZ6V__"